import { forwardRef } from "react";

const Icon = (props, ref) => {
  const { children } = props;
  const forwardProps = { ...props, "aria-hidden": true };

  return (
    <i {...forwardProps} ref={ref}>
      {children}
    </i>
  );
};

export default forwardRef(Icon);
